/**
 * Contact Form.
 * 
 * Move between contact form blocks on button click if form is valid.
 */

const initFor = ($wrapper) => {

	const scrollToTarget = require('../helpers/scrollToTarget');
	const $form = $wrapper.querySelector('form');
	if (!$form) return;
	const action = $form.action;

	const $nexts = $wrapper.querySelectorAll('.js-contact-form-next');
	const $backs = $wrapper.querySelectorAll('.js-contact-form-back');

	const $success = $wrapper.querySelector('.js-contact-form-success');
	const $error = $wrapper.querySelector('.js-contact-form-error');
	
	const toggleMessages = (showSuccess, showError) => {
		$success.classList.toggle('is-hidden', !showSuccess);
		$error.classList.toggle('is-hidden', !showError);
	}

	const resetToFirstStep = () => {
		const $firstSteps = $wrapper.querySelectorAll(`[data-step="1"]`);
		const $steps = $wrapper.querySelectorAll(`[data-step]`);
		const $floatLabels = $wrapper.querySelectorAll('.js-float-label');
		$steps.forEach($step => $step.classList.remove('is-active'));
		$firstSteps.forEach($firstStep => $firstStep.classList.add('is-active'));
		$floatLabels.forEach($floatLabel => $floatLabel.classList.remove('is-active', 'is-success', 'is-error'));
		$form.reset();
	}

	const handleSubmit = (showSuccess, showError) => {
		toggleMessages(showSuccess, showError);
		scrollToTarget($wrapper);
		resetToFirstStep();
	}

	const listenForStepChange = ($element, modifier, shouldValidate = true) => {
		// Figure out what current step is
		const $closest = $element.closest('[data-step]');
		if (!$closest) return;
		// Figure out if target step exists
		const current = Number($closest.getAttribute('data-step'));
		const $currents = $wrapper.querySelectorAll(`[data-step="${current}"]`);
		const target = current + modifier;
		const $targets = $wrapper.querySelectorAll(`[data-step="${target}"]`);
		if ($targets.length === 0) return;
		// Change active steps on click
		$element.addEventListener('click', () => {
			if (!shouldValidate || $($form).valid()) {
				$currents.forEach($el => $el.classList.remove('is-active'));
				$targets.forEach($el => $el.classList.add('is-active'));
			}
		})
	}

	const postForm = (action, $form) => {
		window.POSTBARE(action, new FormData($form))
			.then(data => {
				try {
					const json = JSON.parse(data.response);
					handleSubmit(json.Success, !json.Success);
				} catch (e) {
					console.error(e);
					handleSubmit(false, true);
				}
			})
			.catch(response => {
				console.error(response);
				handleSubmit(false, true);
			});
	}	

	$nexts.forEach($next => {
		listenForStepChange($next, 1);
	})

	$backs.forEach($back => {
		listenForStepChange($back, -1, false);
	})


	if (action && $success && $error) {
		$form.addEventListener('submit', (e) => {
			if (!$($form).valid()) return;
			e.preventDefault();

			// Hide, in case user has submitted before
			toggleMessages(false, false);


			var reCaptchaSiteKey = event.target.getAttribute('data-recaptcha-sitekey') || '';
			var reCaptchaFieldName = event.target.getAttribute('data-recaptcha-field') || '';
			var reCaptchaAction = event.target.getAttribute('data-recaptcha-action') || 'businessformContact';
			
			if (!!reCaptchaSiteKey && !!reCaptchaFieldName && grecaptcha) {
				grecaptcha.ready(function() {
					grecaptcha.execute(reCaptchaSiteKey, { action: reCaptchaAction }).then(function (token) {
						var input = document.getElementById(reCaptchaFieldName);
						input.setAttribute('value', token);
						postForm(action, $form);
					});
				});
			} else {
				postForm(action, $form);
			}
		});
	}
}

const init = () => {
	document.querySelectorAll('.js-contact-form').forEach($form => initFor($form));
};

module.exports = init;
